import { isEmpty } from "lodash";
import StringUtils from "../StringUtils";
import ApiService from "../ApiService";
import TiffUtils from "./tiffUtils";
import DataUtils from "./dataUtils";
import jsPDF from 'jspdf';
import ImageUtils from "./imageUtils";

export default class PdfUtils {
  static exportFileAsPDF = doc => {
    var filename = !isEmpty(doc.referral_document_name) ? doc.referral_document_name : doc.name;
    if (doc.url && StringUtils.getFileExtension('path', doc.url) !== '.zip') {
      ApiService.getPDFFileAsBlob(doc.url).then(res => {
        const blob = new Blob([res.data], { type: res.data.type });
        var documents = [blob];

        TiffUtils.exportAsTif(documents, filename, null, null, false);
      });
    }
  };

  static downloadFileAsPDF = doc => {
    if (doc.url) {
      ApiService.getFileDownload(
        doc.url,
        !isEmpty(doc.referral_document_name) ? doc.referral_document_name : doc.name,
      );
      return;
    }
  };

  static generatePatientDetailsPDF = (
    patientDetails,
    uploadedFileObjects,
    referralDetails,
    filename,
    currentUser,
    is_fax,
  ) => {
    var count = 0;
    return new Promise((resolveVal, reject) => {
      if (!isEmpty(uploadedFileObjects)) {
        new Promise((resolve, reject) => {
          var files = [];
          Object.keys(uploadedFileObjects).forEach(key => {
            uploadedFileObjects['' + key].forEach((doc, _) => {
              count++;
              if (doc.url && StringUtils.getFileExtension('path', doc.url) !== '.zip') {
                ApiService.getPDFFileAsBlob(doc.url).then(res => {
                  const blob = new Blob([res.data], { type: res.data.type });
                  files.push(blob);
                  if (count === files.length) {
                    resolve(files);
                  }
                });
              }
            });
          });
        }).then(documents => {
          PdfUtils.preparePdf(
            documents,
            patientDetails,
            referralDetails,
            resolveVal,
            filename,
            currentUser,
            is_fax,
          );
        });
      }
    });
  };

  static preparePdf = (
    documents,
    patientDetails,
    referralDetails,
    resolveVal,
    filename,
    currentUser,
    is_fax,
  ) => {
    const doc = new jsPDF({
      format: 'legal',
      unit: 'mm',
    });
    if (!isEmpty(patientDetails) && !isEmpty(referralDetails)) {
      DataUtils.appendReferralDetails(
        patientDetails,
        doc,
        referralDetails,
        documents,
        resolveVal,
        filename,
        currentUser,
        is_fax,
      );
    } else if (!isEmpty(documents) && documents[documents.length - 1].type === 'application/pdf') {
      ImageUtils.appendDocuments(documents, doc, resolveVal, filename);
    } else if (!isEmpty(documents)) {
      ImageUtils.appendImages(documents, doc, resolveVal, filename);
    }
  };
}
